import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {RegionFilterComponent} from '../../../general-components/filter/region-filter/region-filter.component';
import {LocalCustomerFilterComponent} from '../../../general-components/filter/local-customer-filter/local-customer-filter.component';
import {ContractTypeFilterComponent} from '../../../general-components/filter/contract-type-filter/contract-type-filter.component';
import {AllSettingsFilterModel} from '../../../../models/AllSettingsFilterModel';
import {forkJoin, Observable, Subscription} from 'rxjs';
import {Offset} from '../../../../models/Offset';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {ProviderAnagrafService} from '../../../general-services/service-provider-anagraf/provider-anagraf.service';
import {RegionService} from '../../../general-services/service-region-anagraf/region-service.service';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import {ContractTypeService} from '../../../general-services/service-contract-type/contract-type.service';
import {MatDialog} from '@angular/material';
import {UserModel} from '../../../../models/UserModel';
import {GenericArray} from '../../../../models/GenericArray';
import {DialogYearMonthComponent} from '../../../general-components/dialog-year-month/dialog-year-month.component';
import {TransformationService} from '../service-transformation/transformation.service';
import {TransformationModel} from '../../../../models/TransformationModel';
import * as toastr from 'toastr';
import * as FileSaver from 'file-saver';
import {ServiceVariantService} from "../../../general-services/service-service-variant-anagraf/service-variant.service";
import {ServiceVariantFilterComponent} from "../../../general-components/filter/service-variant-filter/service-variant-filter.component";
import {NumAnnoMeseService} from "../../../general-services/service-num-anno-mese/num-anno-mese.service";
import {BaseGeneralComponent} from "../../../BaseGeneralComponent";
@Component({
  selector: 'app-filter-transformation',
  templateUrl: './filter-transformation.component.html',
  styleUrls: ['./filter-transformation.component.scss']
})
export class FilterTransformationComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  @Input() showNewEditDelete?: boolean;
  @Input() filter?: TransformationModel;
  @Input() reportSection?: boolean;

  regionData: any;
  localCustomerData: any;
  contractTypeData: any;
  serviceVariantData: any;
  numAnnoMeseData: any;


  @Output() dataFiltered = new EventEmitter<any>();

  @ViewChild(RegionFilterComponent) regionFilterComponent;
  @ViewChild(LocalCustomerFilterComponent) localCustomerFilterComponent;
  @ViewChild(ContractTypeFilterComponent) contractTypeFilterComponent;
  @ViewChild(ServiceVariantFilterComponent) serviceVariantFilterComponent;

  filterSingle: AllSettingsFilterModel;
  getNameSubscribe: Subscription;
  downloadSubscribe: Subscription;
  offset: Offset;
  fileName: string;
  dataSource: any;
  intermittentBool: boolean;

  constructor(private loaderService: LoaderService,
              private transformationService: TransformationService,
              private providerService: ProviderAnagrafService,
              private regionService: RegionService,
              private localCustomerService: LocalCustomerAnagrafService,
              private contractTypeService: ContractTypeService,
              private serviceVariantService: ServiceVariantService,
              private numAnnoMeseService: NumAnnoMeseService,
              private dialog: MatDialog) {
    super();
    this.loaderService.display(true);
  }

  ngOnInit() {
    if (!this.filter) {
      this.filter = new TransformationModel();
    }
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromTransformationModel(this.filter);
    this.offset = new Offset(10, 0);
    if (this.showNewEditDelete === undefined) {
      let user: UserModel;
      this.showNewEditDelete = true;
      user = JSON.parse(sessionStorage.getItem('user'));
      this.filter.region = user.regionList[0];
      this.filterSingle.region = user.regionList[0];
    }

    this.initFilter(this.filterSingle);
  }

  initFilter(allSettingsFilterModel: AllSettingsFilterModel, isReset?: boolean) {

    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      allSettingsFilterModel
    ).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllServiceVariantObservable: Observable<any> = this.serviceVariantService.getListInAllSettings(
      this.serviceVariantService.baseUrl,
      allSettingsFilterModel).pipe();
    const getAllNumAnnoMeseObservable: Observable<any> = this.numAnnoMeseService.getAllMonth(
      this.filter.contractType).pipe();


    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable,
                      getAllContractTypeObservable, getAllServiceVariantObservable,
                      getAllNumAnnoMeseObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];
          this.serviceVariantData = resultFork[3];
          this.numAnnoMeseData = resultFork[4];

          if (!isReset) {
            this.loaderService.display(false);
          } else {
            this.dataFiltered.emit(this.filter);
          }
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptRegionChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.region = event;

    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllServiceVariantObservable: Observable<any> = this.serviceVariantService.getListInAllSettings(
      this.serviceVariantService.baseUrl,
      this.filterSingle).pipe();

    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllServiceVariantObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.localCustomerData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.serviceVariantData = resultFork[2];

          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.serviceVariant = this.filterSingle.serviceVariant;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptLocalCustomerChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.localCustomer = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeFilteredObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();
    const getAllServiceVariantObservable: Observable<any> = this.serviceVariantService.getListInAllSettings(
      this.serviceVariantService.baseUrl,
      this.filterSingle).pipe();


    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllContractTypeFilteredObservable);
    observableList.push(getAllServiceVariantObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.contractTypeData = resultFork[1];
          this.serviceVariantData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.contractType = this.filterSingle.contractType;
          this.filter.serviceVariant = this.filterSingle.serviceVariant;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptContractTypeChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.contractType = event;

    const getAllRegionFilteredObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerFilteredObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllServiceVariantObservable: Observable<any> = this.serviceVariantService.getListInAllSettings(
      this.serviceVariantService.baseUrl,
      this.filterSingle).pipe();


    observableList.push(getAllRegionFilteredObservable);
    observableList.push(getAllLocalCustomerFilteredObservable);
    observableList.push(getAllServiceVariantObservable);

    forkJoin(observableList)
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.serviceVariantData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.serviceVariant = this.filterSingle.serviceVariant;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }

  interceptMilestoneNumberChange(event) {
    this.filter.milestoneNumber = event;
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }
  }

  interceptServiceVariantChange(event) {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = true;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const observableList: Array<Observable<any>> = new Array<Observable<any>>();
    this.filterSingle.serviceVariant = event;

    const getAllRegionObservable: Observable<any> = this.regionService.getListInAllSettings(
      this.regionService.baseUrl,
      this.filterSingle).pipe();
    const getAllLocalCustomerObservable: Observable<any> = this.localCustomerService.getListInAllSettings(
      this.localCustomerService.baseUrl,
      this.filterSingle).pipe();
    const getAllContractTypeObservable: Observable<any> = this.contractTypeService.getListInAllSettings(
      this.contractTypeService.baseUrl,
      this.filterSingle).pipe();

    forkJoin([getAllRegionObservable, getAllLocalCustomerObservable, getAllContractTypeObservable])
      .subscribe(
        (resultFork: any) => {
          this.regionData = resultFork[0];
          this.localCustomerData = resultFork[1];
          this.contractTypeData = resultFork[2];

          this.filter.region = this.filterSingle.region;
          this.filter.localCustomer = this.filterSingle.localCustomer;
          this.filter.contractType = this.filterSingle.contractType;

          this.loaderService.display(false);
        }, error => {
          console.log(error);
          this.loaderService.display(false);
        });
  }


  filterTable(): void {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    this.getAllFilters();
    if (!this.reportSection) {
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.TRANSFORMATION_FILTER, JSON.stringify(this.filter));
    }
    this.dataFiltered.emit(this.filter);
  }

  reset() {
    this.loaderService.display(true);
    if (!this.reportSection) {
      this.intermittentBool = false;
      this.intermittentFilterButton(this.intermittentBool);
    }

    const isReset = true;
    this.filter = new TransformationModel();
    this.filter.provider = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED));
    this.filterSingle = AllSettingsFilterModel.getFromTransformationModel(this.filter);
    this.contractTypeService.getListInAllSettings(this.contractTypeService.baseUrl, this.filterSingle).subscribe(
      (resultContractType: any) => {
      this.contractTypeData = resultContractType;
      sessionStorage.setItem(this.SESSION_STORAGE_LABELS.TRANSFORMATION_FILTER, JSON.stringify(this.filter));
      this.filterSingle = AllSettingsFilterModel.getFromTransformationModel(this.filter);
      this.initFilter(this.filterSingle, isReset);
    }, error => {
      console.log(error);
      this.loaderService.display(false);
    });
  }

  getAllFilters() {
    this.filter.localCustomer = this.localCustomerFilterComponent.optionSelected;
    this.filter.region = this.regionFilterComponent.optionSelected;
    this.filter.contractType = this.contractTypeFilterComponent.optionSelected;
    this.filter.serviceVariant = this.serviceVariantFilterComponent.optionSelected;
  }

  downloadTableCsv() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.transformationService.getNameGenerateCsv(this.offset, this.filter)
      .subscribe(
        resultPage => {
          this.fileName = resultPage.toString();
          this.downloadSubscribe = this.transformationService.getDownloadCsv(this.fileName)
            .subscribe( data => {
              toastr.success('CSV downloaded with success', 'Success');
              this.loaderService.display(false);
              FileSaver.saveAs(new Blob([data], { type: 'text/csv' }), this.fileName);
            });
        }, () => {
          toastr.error('Problem during download CSV, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  downloadTableXls() {
    this.loaderService.display(true);
    this.getAllFilters();

    this.getNameSubscribe = this.transformationService.getNameGenerateXlsx(this.offset, this.filter)
      .subscribe(
        resultPage => {
          const currentDate = new Date();
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'transformation_' + currentDate + '.xlsx');
          } else {
            FileSaver.saveAs(new Blob(
              [resultPage],
              { type: this.EXCEL_TYPE }),
              'transformation_' + currentDate + '.xlsx');
          }
          toastr.success('XLS downloaded with success', 'Success');

          this.loaderService.display(false);
        }, () => {
          toastr.error('Problem during download XLS, please contact the Administrator', 'Error');
          this.loaderService.display(false);
        });
  }

  ngOnDestroy(): void {
  }
}
